import axios from 'axios'
import { Moment } from "moment"

const url = process.env.REACT_APP_URL

export const getCountTrayError = async (
  range: { start: Moment | null | undefined, end: Moment | null | undefined } | undefined = undefined
) => {
  try {
    let data: any;
    if (range?.start && range.end) {
      data = await axios.get(url + '/tray/getTrayCountError',
        { params: { start: new Date(range.start.toString()).toUTCString(), end: new Date(range.end.toString()).toUTCString() } }
      )
    } else {
      data = await axios.get(url + '/tray/getTrayCountError')
    }
    return data.data
  } catch (err) {
    return err
  }
}

export const getCountTray = async (
  status: any[] | undefined,
  range: { start: Moment | null | undefined, end: Moment | null | undefined } | undefined = undefined
) => {
  try {
    let data: any;
    if (range?.start && range?.end) {
      data = await axios.get(url + '/tray/getCountTrayScanned',
        { params: { start: new Date(range.start.toString()).toUTCString(), end: new Date(range.end.toString()).toUTCString(), status: status } }
      )
    } else {
      data = await axios.get(url + '/tray/getCountTrayScanned', { params: { status: status } })
    }
    return data.data
  } catch (err) {
    return err.code
  }
}

export const getCountTrayDate = async (start: Date | undefined, end: Date | undefined, status: string[]) => {
  try {
    const data = await axios.get(url + '/tray/getCountTrayDate', {
      params: { status: status, start: start, end: end }
    })
    return data.data
  } catch (err) {
    return err.code
  }
}

export const getCountTrayMonth = async (range: { start: Moment | null | undefined, end: Moment | null | undefined } | undefined = undefined) => {
  try {
    const data = await axios.get(url + '/tray/getCountTrayMonth', {
      params: { start: range?.start?.utcOffset(0).toString(), end: range?.end?.toISOString(false) }
    })
    return data.data
  } catch (err) {
    return []
  }
}

function mergeList(list: any[], olpn: any) {
  var result: any[] = []

  result.push(list.map((elem) => {
    const found = olpn.findIndex((i) => {
      return i._id === elem.OLPN
    })

    if (found >= 0) {
      elem.OLPN = olpn[found]
    }
    return elem
  }))
  return result
}

export const getTrayFromBp = async (bpId: string, status: string = "SUCCESS") => {
  try {
    const res = await axios.get(url + '/tray/getTrayFromBp', {
      params: {
        bpId: bpId,
        status: status
      }
    })
    if (res.status === 200) {
      res.data.trays.forEach((elem, index) => res.data.trays[index].skuList = typeof elem.skuList === 'string' ? JSON.parse(elem.skuList.replace(/'/g, '"')) : elem.skuList)
      var trays = res.data.trays
      var olpns = res.data.olpn
      const merge = mergeList(trays, olpns)
      return merge[0]
    }
  } catch (err) {
    console.log(err)
    return err
  }
}

export const saveExtractedData = async (bpId: number | undefined, trayNumber: any, path: string | null, status: string, skuList: any, braceletCount: number, OLPN: string, forced: boolean = false) => {

  const timestamp = {
    scan: sessionStorage.getItem("scan_start"),
    photo: sessionStorage.getItem("take_photo"),
    AI: sessionStorage.getItem("AI"),
    complete: new Date().toISOString(),
  }

  try {
    let obj: any = {
      bpId: bpId,
      trayNumber: trayNumber,
      path: path,
      status: status,
      skuList: skuList,
      braceletCount: braceletCount,
      OLPN: OLPN,
      timestamp: timestamp
    }
    if (forced)
      obj.forced = true
    const res = await axios.post(url + "/tray/saveTray", obj)
    sessionStorage.removeItem("result")
    return res.data
  } catch (err) {
    console.log(err)
  }
}

export const getRejectedRate = async (start: Moment | null | undefined, end: Moment | null | undefined): Promise<any[] | undefined> => {
  try {
    const res = await axios.get(url + "/tray/getRejectRate", {
      params: { start: start?.toString(), end: end?.toString() }
    })
    return res.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const updateTray = async (status: string | undefined, skuList: any[], braceletCount: number, path: string | null, trayNumber: string | undefined, bpId: string) => {
  try {
    const res = await axios.post(url + '/tray/updateTray',
      {
        bpId: bpId,
        trayNumber: trayNumber,
        path: path,
        skuList: skuList,
        status: status,
        braceletCount: braceletCount
      })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const updateTrayData = async (_id: string, data) => {
  try {
    const res = await axios.post(url + "/tray/updateTrayData", {
      _id: _id,
      ...data
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const getPendingTrayCount = async (bpId: string) => {
  try {
    const res = await axios.get(url + "/tray/getPendingTrayCount", {
      params: {
        bpId: bpId
      }
    })
    if (res.data)
      return res.data
    else return res.status
  } catch (err) {
    console.log(err)
    return err
  }
}